import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/attributes/prop/prop.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/traversal/add/add.js";
import "dabbyjs/src/traversal/eq/eq.js";
import "dabbyjs/src/traversal/closest/closest.js";
import "dabbyjs/src/manipulation/insert/insert.js";
import "dabbyjs/src/manipulation/empty/empty.js";
import "dabbyjs/src/manipulation/remove/remove.js";
import "dabbyjs/src/attributes/attr/attr.js";
import "dabbyjs/src/attributes/class/class.js";
import "dabbyjs/src/attributes/data/data.js";
import "dabbyjs/src/core/each/each.js";
import "dabbyjs/src/manipulation/insertto/insertto.js";
import "dabbyjs/src/traversal/children/children.js";
import "dabbyjs/src/traversal/next-prev/next-prev.js";
import error from "./error.js";
import {getfiles, setfiles} from "./table.js";

function updateSelection(obj, files, current = null) {
	obj.each(function () {
		const $this = $(this),
			val = $this.attr("value");
		$this.prop("checked", !files[val].hasOwnProperty("tags") ? false : (current === null ? files[val].tags.length === 0 : files[val].tags.includes(current)));
	});
}

function updateTags(obj, files, tags, cls) {
	obj.each(function () {
		const item = $(this),
			val = item.attr("value"),
			label = item.next(),
			containercls = cls + "__label-tags";

		// ensure container exists
		let container = $("." + containercls, label);
		if (container.length === 0) {
			container = $("<div>", {"class": containercls}).appendTo(label);
		}

		// map the items
		const items = {};
		container.children().each(function () {
			const $this = $(this),
				id = $this.data("tag-id");
			if (id) {
				items[id] = $this;
			}
		});

		// apply tags, ignoring any that are no longer configured
		(files[val].tags || []).forEach(value => {
			if (value && typeof tags[value] !== "undefined") {
				if (!items.hasOwnProperty(value)) {
					container.append($("<div>", {"class": containercls + "-item", "data-tag-id": value, text: tags[value].name, title: tags[value].title}));
				}
				delete items[value];
			}
		});

		// remove left over tags
		for (const id in items) {
			items[id].remove();
		}
	});
}

export default (nav, obj, config) => {
	if (obj.length) {

		// install tagging controls
		const cls = obj.attr("class").split(" ").reverse()[0],
			active = cls + "__tags-item--active",
			div = $("<div>", {"class": cls + "__tags"}),
			files = getfiles();
		let controls = $();

		// render tag controls
		let buttons = $(),
			current = null,
			first = true;
		for (let [id, tag] of Object.entries(config.tags)) {
			id = parseInt(id);

			// set first button on
			if (first) {
				current = id;
				first = false;
			}

			// render button
			const button = $("<div>", {
				text: tag.name,
				title: tag.title,
				"class": cls + "__tags-item" + (current === id ? " " + active : ""),
				click: button => {
					buttons.each((i, item) => {
						if (item !== button.target || current !== id) {
							$(item).toggleClass(active, item === button.target && current !== id);
						}
					});
					current = id;
					updateSelection(controls, files, current);
				}
			});
			div.append(button);
			buttons = buttons.add(button);
		};
		obj.append(div);

		// write the selected files into the fieldset control for tagging
		nav.on("change", () => {

			// remove current items from the fieldset control
			$(".ar-selectcontent__group, .ar-selectcontent__item", obj).remove();

			// add new items
			let group = null,
				currgroup = null,
				rows = $();
			controls = $();
			files.forEach((item, i) => {
				const input = $("<input>", {
					tabindex: -1,
					type: "checkbox",
					name: "tags[]",
					id: "tags-" + i,
					"class": "form__control-fieldset-input ar-selectcontent__input",
					value: i
				})
					.on("change", function () {
						const item = $(this),
							checked = item.prop("checked");

						// create array if it doesn't exist
						if (!files[i].tags) {
							files[i].tags = [];
						}

						// set the value
						const index = files[i].tags.indexOf(current);

						// adding and not in array
						if (index === -1 && checked) {
							files[i].tags.push(current);

						// remove from array
						} else if (index > -1 && !checked) {
							files[i].tags.splice(index, 1);
						}

						// set selection
						updateSelection(controls, files, current);

						// update the interface
						updateTags(controls, files, config.tags, cls);
					});
				controls = controls.add(input);

				// add group header
				if ((item.group || null) !== currgroup) {
					group = $("<fieldset>", {"class": "form__control-fieldset-group ar-selectcontent__group"})
						.append($("<legend>", {
							"class": "form__control-fieldset-group-legend ar-selectcontent__group-legend",
							text: item.group
						}));
					rows = rows.add(group);
					currgroup = item.group;
				}

				// cache the thumbnail, as this list is rebuilt every time the screen is shown
				if (item instanceof File && !item.thumb) {
					item.thumb = URL.createObjectURL(item);
				}

				// add row
				const row = $("<div>", {"class": "form__control-fieldset-item ar-selectcontent__item"})
					.append(input)
					.append(
						$("<label>", {tabindex: 0, for: "tags-" + i, "class": "form__control-fieldset-label ar-selectcontent__label"})
							.append(
								$("<div>", {"class": "ar-selectcontent__thumb"})
									.append($("<img>", {src: item.thumb, "class": "ar-selectcontent__thumb"}))
							)
							.append($("<div>", {"class": "ar-selectcontent__title", text: item.name}))
					);
				if (currgroup !== null) {
					group.append(row);
				} else {
					rows = rows.add(row);
				}
			});
			obj.prepend(rows); // add before the tagging control

			// set selection and tags
			updateSelection(controls, files, current);
			updateTags(controls, files, config.tags, cls);
		});

		// check we have tagged everything
		$("#hashform-tags-next").on("click", e => {
			const items = files.filter(item => (item.tags || []).length > 0)

			// at least one file is tagged, and every tagged file has at least one required tag
			if (items.length > 0 && items.every(item => item.tags.some(tag => config.tags[tag]?.required))) {
				setfiles(files.filter(item => (item.tags || []).length > 0)); // update the file list to remove untagged items
			} else {
				error(obj.closest(".hashform__item"), config.translations.tags);
				e.preventDefault();
			}
		});
	}
};